import {
  useCallback, useEffect,
} from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from '~/_shared/utils/hooks/useSelector';
import { createStateSelector } from '~/_shared/utils/memoize/createSelector';
import { demographicsListGlobalFetchDataRequest } from '~/store/demographics/demographicsListGlobal/demographicsListGlobal.actionCreators';
import {
  demographicsListGlobalRegionsSelector,
  useDemographicsListGlobalIsLoadedSelector,
  useDemographicsListGlobalIsLoadingSelector,
} from '~/store/demographics/demographicsListGlobal/demographicsListGlobal.selectors';

const selectDemographicToRegionMap = createStateSelector(
  demographicsListGlobalRegionsSelector,
  (regions) => regions.reduce((acc, region) => {
    region.demographics.forEach(demographic => {
      acc[demographic.id] = region.id;
    });
    return acc;
  }, {} as Record<string, string>),
);

export const useGetMetricRegion = () => {
  const areDemographicRegionsLoading = useDemographicsListGlobalIsLoadingSelector();
  const areDemographicRegionsLoaded = useDemographicsListGlobalIsLoadedSelector();
  const dispatch = useDispatch();

  useEffect(() => {
    if (!areDemographicRegionsLoaded && !areDemographicRegionsLoading) {
      dispatch(demographicsListGlobalFetchDataRequest());
    }
  }, [areDemographicRegionsLoaded, areDemographicRegionsLoading, dispatch]);

  const demographicToRegionMap = useSelector(selectDemographicToRegionMap);

  const getMetricRegion = useCallback(
    (demographicId: string) => demographicToRegionMap[demographicId],
    [demographicToRegionMap],
  );

  return {
    getMetricRegion,
  };
};
